<template>
  <div class="ti-knowledge-container">
    <div class="ti-knowledge-box">
      <div class="ti-knowledge-left">
        <div class="title">选择知识点</div>
        <div class="knowledge-tree">
          <el-tree
            ref="tree"
            :props="treeProps"
            :load="loadNode"
            lazy
            show-checkbox
            @check="onTreeCheckChange"
          >
          </el-tree>
        </div>
      </div>
      <div class="ti-knowledge-right">
        <div class="categroy category-container clearfix">
          <dl class="topic-dl flex-between">
            <dt><i class="wkcourse_icon"></i>题型</dt>
            <dd>
              <a
                href="javascript:;"
                :class="{ crt: query.questionType == v.code }"
                v-for="(v, i) in topicList"
                :key="i"
                @click="onQuestionType(v.code)"
                >{{ v.name }}</a
              >
            </dd>
          </dl>
          <dl class="wktype flex-between">
            <dt><i class="wkcourse_icon"></i>难度</dt>
            <dd>
              <a
                href="javascript:;"
                :class="{ crt: query.difficulty == v.code }"
                v-for="(v, i) in difficultyList"
                :key="i"
                @click="onDifficulty(v.code)"
                >{{ v.name }}</a
              >
            </dd>
          </dl>
          <dl class="wktype flex-between">
            <dt><i class="el-icon-date"></i>年份</dt>
            <dd>
              <a
                href="javascript:;"
                :class="{ crt: query.year == v.code }"
                v-for="(v, i) in yearList"
                :key="i"
                @click="onYear(v.code)"
                >{{ v.name }}</a
              >
            </dd>
          </dl>
        </div>
        <div class="topic-container">
          <div class="topic-top flex-between">
            <div class="sort-list flex-row-start">
              <span class="sort-item active">综合</span>
              <!-- <span class="sort-item">最新</span>
              <span class="sort-item">最热</span> -->
            </div>
            <!-- <el-checkbox v-model="isAnswerChecked">显示答案和解析</el-checkbox> -->
            <div>
              <el-pagination
                small
                layout="total,prev, pager, next"
                :current-page="query.page"
                :page-size="query.pageSize"
                :total="pageTotal"
                @current-change="handlePageChange"
              >
              </el-pagination>
            </div>
          </div>
          <div v-if="isLoading" class="loading-box font-12 column">
            <div class="c-40b8ee">
              <i class="el-icon-loading"></i
              ><span class="loading-text">拼命加载中</span>
            </div>
          </div>
          <template v-else>
            <div class="list-container" v-if="isNull">
              <div
                class="question-section"
                v-for="(exercise, i) in exerciseList"
                :key="i"
              >
                <div class="question-container">
                  <div
                    class="question-content"
                    @click="onLooksExplain(exercise)"
                  >
                    <div class="question-context">
                      <div
                        class="question-stem"
                        v-html="exercise.context.stem"
                      ></div>
                      <div class="question-options">
                        <ul
                          v-if="exercise.context.options"
                          style="display: grid; grid-template-columns: auto auto;"
                        >
                          <li
                            v-for="(options, index) in exercise.context.options"
                            :key="index"
                            v-html="optionHtml(index, options)"
                          ></li>
                        </ul>
                        <template v-if="exercise.isTrue">
                          <div
                            v-for="(explain, explain_index) in exercise.explain"
                            :key="explain_index"
                          >
                            <div class="question-answer" style="clear:both">
                              <div
                                class="ques-title ques-type"
                                :class="{
                                  inlineBlock:
                                    exercise.context.options ||
                                    exercise.quesType.name == '判断题',
                                }"
                              >
                                【答案】
                              </div>
                              <div
                                v-for="(answers,
                                answers_key) in explain.answers"
                                :key="answers_key"
                                class="question-answer-text"
                              >
                                <span
                                  v-for="(answers_value, a_i_1) in answers"
                                  :key="a_i_1"
                                  v-html="answers_value"
                                ></span>
                              </div>
                            </div>
                            <div class="question-parsing">
                              <div class="ques-title ques-type">【解析】</div>
                              <div v-html="explain.analysis"></div>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                    <template v-if="exercise.children">
                      <div
                        class="question-context"
                        v-for="(children, childrenKey) in exercise.children"
                        :key="childrenKey"
                      >
                        <template v-if="children.context">
                          <div
                            class="question-stem"
                            v-html="children.context.stem"
                          ></div>
                          <div class="question-options ">
                            <ul
                              style="display: grid; grid-template-columns: auto auto;"
                            >
                              <li
                                v-for="(childrenOptions,
                                childrenOptionsKey) in children.context.options"
                                :key="childrenOptionsKey"
                                v-html="
                                  optionHtml(
                                    childrenOptionsKey,
                                    childrenOptions
                                  )
                                "
                              ></li>
                            </ul>
                            <template v-if="exercise.isTrue">
                              <div
                                style="clear:both"
                                v-for="(childrenExplain,
                                childrenExplainKey) in children.explain"
                                :key="childrenExplainKey"
                              >
                                <div class="question-answer">
                                  <div
                                    class="ques-title ques-type"
                                    :class="{
                                      inlineBlock:
                                        children.context.options ||
                                        exercise.quesType.name == '判断题',
                                    }"
                                  >
                                    【答案】
                                  </div>
                                  <div
                                    v-for="(answer_v,
                                    answer_i) in childrenExplain.answers"
                                    :key="answer_i"
                                    class="question-answer-text"
                                  >
                                    <span
                                      v-for="(answer_v_1,
                                      answer_i_1) in answer_v"
                                      :key="answer_i_1"
                                      v-html="answer_v_1"
                                    ></span>
                                  </div>
                                </div>
                                <div class="question-parsing">
                                  <div class="ques-title ques-type">
                                    【解析】
                                  </div>
                                  <div v-html="childrenExplain.analysis"></div>
                                </div>
                              </div>
                            </template>
                          </div>
                        </template>
                      </div>
                    </template>
                  </div>
                  <div
                    class="ques-knowledge "
                    v-if="exercise.isTrue"
                    style="clear:both"
                  >
                    <div class="ques-title ques-type">【考点】</div>
                    <div class="knowledge-list">
                      <span
                        class="knowledge-text"
                        v-for="(k_value, k_index) in exercise.knowledge"
                        :key="k_index"
                        >{{ k_value.name }}</span
                      >
                    </div>
                  </div>
                  <div class="  clearfix" style="clear:both">
                    <div class="question-bottom flex-between">
                      <div class="question-info">
                        <span
                          >更新：{{ exercise.updateTime | getLocalTime }}</span
                        >
                        <span>题型：{{ exercise.quesType.name }}</span>
                        <span>难度：{{ exercise.difficulty.name }}</span>
                        <span>组卷：{{ exercise.useCount }}</span>
                      </div>
                      <div class="question-operation">
                        <div class="operation">
                          <i class="el-icon-tickets"></i>
                          <span class="operation-text">详情</span>
                        </div>
                        <div class="operation">
                          <i class="el-icon-edit-outline"></i>
                          <span class="operation-text">纠错</span>
                        </div>
                        <div class="operation">
                          <i class="el-icon-star-off"></i>
                          <span class="operation-text">收藏</span>
                        </div>
                        <el-button
                          type="danger"
                          icon="el-icon-minus"
                          size="mini"
                          round
                          @click="onRemoveQuestion(exercise)"
                          v-if="exercise.isAdd"
                          >试题篮</el-button
                        >
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          size="mini"
                          round
                          @click="onAddQuestion(exercise)"
                          v-else
                          >试题篮</el-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="clearfix list-page">
                <div class="mr-10">
                  <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.page"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>
            <div class="list-container column" v-else>
              <img src="../../assets/images/list_null.png" alt="" srcset="" />
              <div class="null">暂无数据~~</div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <basket
      :stageCode="stageSubject.stage.code"
      :subjectCode="stageSubject.subject.code"
      @deleteCallBack="onDeleteCallBack"
      ref="basketRef"
    ></basket>
  </div>
</template>
<script>
import Vue from "vue";
Vue.prototype.optionHtml = function(i, v) {
  // to do
  let html = ["A", "B", "C", "D"];
  return html[i] + "." + v;
};
import { mapState } from "vuex";
import Basket from "../template/Basket.vue";
export default {
  components: { Basket },
  data() {
    return {
      query: {
        page: 1,
        pageSize: 20,
        stageSubject: "",
        questionType: "",
        year: "",
        difficulty: "",
        knowledge: "",
      },
      isLoading: true,
      isNull: true,
      pageTotal: 0,
      optionsHtml: ["A", "B", "C", "D"],
      yearList: [
        {
          code: "",
          name: "全部",
        },
      ],
      difficultyList: [
        {
          name: "全部",
          code: "",
        },
      ],
      topicList: [
        {
          name: "全部",
          code: "",
        },
      ],
      treeList: [],
      exerciseList: [],
      isAnswerChecked: false,
      treeProps: {
        children: "children",
        label: "name",
      },
      userBasketList: [],
      userBasketTotalCount: 0,
    };
  },
  computed: {
    ...mapState(["stageSubject"]),
  },
  created() {
    this.categoryId = this.stageSubject.subject.children[0].relationCategoryId;
    this.query.stageSubject = this.stageSubject.subject.code;
    this.getTopicTypes(this.stageSubject.subject.code);
    this.getDifficulty();
    this.getYear();
    this.getExercise();
    // this.getUserQuestion();
  },
  filters: {
    optionsHtml: function(v) {
      return v;
    },
    getLocalTime: function(v) {
      return new Date(parseInt(v) * 1000).toLocaleString();
    },
  },
  methods: {
    getTopicTypes(subjectCode) {
      this.getRequest("/wenjiaoopne/kc/index/pingTaiApis", {
        url: "/cfg-dict/v1/biz/dictionaryapi/get-arbitrarily-dict",
        appId: "100395",
        categoryId: 100185,
        code: subjectCode,
      }).then((result) => {
        this.getTopic(result.data[0].relationCategoryId);
      });
    },
    getTopic(categoryId) {
      this.getRequest("/wenjiaoopne/kc/index/pingTaiApis", {
        url: "/cfg-dict/v1/biz/dictionaryapi/get-dict-by-dictid",
        appId: "100012",
        categoryId: categoryId,
      })
        .then((result) => {
          this.topicList = [...this.topicList, ...result.data];
        })
        .catch(() => {});
    },
    getDifficulty() {
      this.getRequest("/wenjiaoopne/kc/index/pingTaiApis", {
        url: "/cfg-dict/biz/v1/dictionaryapi/get-dict-by-level",
        appId: "100085",
        categoryId: 100186,
        level: 1,
      })
        .then((result) => {
          this.difficultyList = [...this.difficultyList, ...result.data];
        })
        .catch(() => {});
    },
    getYear() {
      this.getRequest("/wenjiaoopne/kc/index/pingTaiApis", {
        url: "/cfg-dict/v1/biz/dictionaryapi/get-dict-by-dictid",
        appId: "100012",
        categoryId: 100209,
      })
        .then((result) => {
          this.yearList = [...this.yearList, ...result.data];
        })
        .catch(() => {});
    },
    getExercise() {
      this.getRequest("/wenjiaoopne/kc/basket/list", this.query)
        .then((result) => {
          this.exerciseList = result.data.list;
          this.pageTotal = result.data.count;
          this.isNull = this.exerciseList.length > 0;
          this.isLoading = false;
        })
        .catch(() => {});
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        // return resolve([{ name: "region" }]);
        this.getRequest("/wenjiaoopne/kc/index/pingTaiApis", {
          url: "/cfg-dict/biz/v1/dictionaryapi/list-all-dicts",
          appId: "100084",
          categoryId: this.categoryId,
        })
          .then((result) => {
            return resolve(result.data);
          })
          .catch(() => {});
      } else {
        this.getRequest("/wenjiaoopne/kc/index/pingTaiApis", {
          url: "/cfg-dict/v1/biz/dictionaryapi/get-dict-by-dictid",
          appId: "100012",
          dictId: node.data.dictId,
        })
          .then((result) => {
            return resolve(result.data);
          })
          .catch(() => {});
      }
    },
    handlePageChange(v) {
      this.$set(this.query, "page", v);
      this.getExercise();
    },
    onQuestionType(v) {
      this.$set(this.query, "questionType", v);
      this.getExercise();
    },
    onDifficulty(v) {
      this.$set(this.query, "difficulty", v);
      this.getExercise();
    },
    onYear(v) {
      this.$set(this.query, "year", v);
      this.getExercise();
    },
    onTreeCheckChange() {
      let _knowledgeArray = [];
      for (const item of this.$refs.tree.getCheckedNodes()) {
        _knowledgeArray.push(item.code);
      }
      this.$set(this.query, "knowledge", _knowledgeArray.join());
      this.getExercise();
    },
    onAddQuestion(item) {
      this.postRequest("/wenjiaoopne/kc/basket/add", {
        questionId: item.questionId,
        stage: this.stageSubject.stage.code,
        subject: this.stageSubject.subject.code,
        subjective: item.subjective.code,
        typeName: item.quesType.name,
        types: item.quesType.code,
        source: 1,
      })
        .then(() => {
          this.$set(item, "isAdd", true);
          this.$refs.basketRef.getUserQuestion();
        })
        .catch(() => {});
    },
    onRemoveQuestion(item) {
      this.postRequest("/wenjiaoopne/kc/basket/remove", {
        questionId: item.questionId,
        stage: this.stageSubject.stage.code,
        subject: this.stageSubject.subject.code,
      })
        .then(() => {
          this.$set(item, "isAdd", false);
          this.$refs.basketRef.getUserQuestion();
        })
        .catch(() => {});
    },
    onDeleteCallBack() {
      this.getExercise();
    },
    onLooksExplain(item) {
      this.$set(item, "isTrue", !item.isTrue);
    },
  },
};
</script>
<style scoped>
@import "../../assets/css/question.css";
.ti-knowledge-container {
  background: #f1f1f1;
}
.ti-knowledge-container::after {
  content: "";
  display: block;
  clear: both;
}
.ti-knowledge-box {
  position: relative;
  width: 1195px;
  margin: 0 auto;
  padding: 10px 0;
}
.ti-knowledge-left {
  float: left;
  width: 270px;
  min-height: 300px;
  background-color: #fff;
  margin-bottom: 10px;
}

.ti-knowledge-left .title {
  padding: 15px;
  border-bottom: 1px solid #eceff3;
  font-size: 14px;
  font-weight: 700;
}
.ti-knowledge-left .knowledge-tree {
  margin: 10px;
  /* height: 450px;
  overflow-y: auto; */
}
.ti-knowledge-right {
  width: 910px;
  float: right;
}
.category-container {
  width: 100%;
  background-color: #fff;
}
.topic-container {
  width: 100%;
  min-height: 400px;
  margin-top: 10px;
  background-color: #fff;
}

.ti-knowledge-right .categroy {
  width: 100%;
  /* height: 180px; */
  background-color: #ffffff;
}
.ti-knowledge-right .categroy dl {
  margin: 0px 20px;
  padding: 5px 0px;
}
.child {
  width: 798px;
  margin: 0 0 13px 92px !important;
  height: 30px !important;
  padding: 0px !important;
  background: #eceff3;
}
.ti-knowledge-right .categroy dl dt {
  width: 72px;
  float: left;
  color: #4f4e4e;
  font-size: 16px;
  line-height: 34px;
  /* border-right: 1px solid #eceff3; */
}
.ti-knowledge-right .categroy dl dt i.wkcourse_icon {
  width: 14px;
  height: 19px;
  display: block;
  background: url(https://wk.canpoint.net/Template/style1/style_img/wkcourse_icon.png)
    0px 0px;
  float: left;
  margin: 8px 10px 0px 0px;
}
.ti-knowledge-right .categroy dl.wktype {
  border-top: 1px solid #eceff3;
}
.ti-knowledge-right .categroy dl.wktype dt i.wkcourse_icon,
.el-icon-date {
  background-position: 0px -25px;
  margin-top: 10px;
}
.el-icon-date {
  color: #41b9f1;
  margin-right: 10px;
}
.ti-knowledge-right .categroy dl dd {
  width: 780px;
  margin-top: 2px;
  margin-left: 15px;
}

.ti-knowledge-right .categroy dl dd a {
  display: inline-block;
  color: #4f4f4f;
  font-size: 14px;
  text-align: center;
  padding: 4px 20px;
  margin: 4px 0;
}
.ti-knowledge-right .categroy dl dd a:hover {
  color: #41b9f1;
}
.ti-knowledge-right .categroy dl dd a.crt {
  background-color: #41b9f1;
  color: #fff;
}
.topic-top {
  border-bottom: 1px solid #eceff3;
  margin-bottom: 20px;
}
.question-answer-text {
  display: inline-block;
  margin-right: 10px;
}
.topic-top .sort-list {
  height: 46px;
  margin-left: 20px;
}
.topic-top .sort-list span {
  display: inline-block;
  padding: 0 15px;
  font-size: 14px;
  height: 20px;
  cursor: pointer;
}

.topic-top .sort-list span:hover {
  color: #41b9f1;
}
.topic-top .sort-list .sort-item.active {
  color: #41b9f1;
}
.topic-top .sort-list .sort-item.active:after {
  content: "";
  width: 40%;
  height: 1px;
  display: block;
  padding-top: 2px;
  margin: 0 auto;
  border-bottom: 2px solid #41b9f1;
}
</style>
